import React, { Component } from "react";
import { Modal, Button, Table, Form, Input, Divider, message, Select } from "antd";
import axios from "../../service/index";
const { Option } = Select;
class Administrators extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pagination: {
        name: "",
        current: 1,
        pageSize: 10,
        total: 0,
        onChange: (a) => {
          let pagination = this.state.pagination;
          pagination.current = a;
          this.setState({ pagination }, this.getTable);
        },
      },
      fromItemShow: false,
      passwordShow: false,
      roleItemShow: false,
      visible: false,
      visiblerole: false,
      getAdminListData: [],
      nodata: "无数据",
      searchData: {
        userName: "",
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      role: undefined,
      adminName: "",
      adminUserName: "",
      labelId: null,
      modelTitle: "新增账号",
      optionList: [],
      columns: [
        {
          title: "员工",
          dataIndex: "name",
          key: "name",
          align: "center",
        },
        {
          title: "部门",
          dataIndex: "groupName",
          key: "groupName",
          align: "center",
        },
        {
          title: "职位",
          dataIndex: "positionName",
          key: "positionName",
          align: "center",
        },
        {
          title: "角色",
          dataIndex: "roleName",
          key: "roleName",
          align: "center",
          // render: (arr) => {
          //   if (arr) {
          //     return (arr || []).map((item, i) => {
          //       return item[i].name;
          //     });
          //   }
          // },
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          render: (record) => (
            <div>
              <span
                style={{ marginRight: "15px", color: "#277FFF", cursor: "pointer" }}
                onClick={() => {
                  this.setState({
                    visible: true,
                    fromItemShow: false,
                    passwordShow: false,
                    roleItemShow: true,
                    modelTitle: "角色分配",
                    editroleIds: record.roleId,
                    labelId: record.id,
                  });
                }}>
                角色分配
              </span>
              {/* <span
                style={{ color: "#277FFF", cursor: "pointer" }}
                onClick={() => {
                  Modal.confirm({
                    title: "删除账号",
                    okText: "确认",
                    cancelText: "取消",
                    content: (
                      <div>
                        <p>账号删除后此账号将无法登录，请谨慎操作！确定要删除吗？</p>
                      </div>
                    ),
                    onOk: () => {
                      this.delAdmin(record.id);
                    },
                  });
                }}>
                删除
              </span> */}
            </div>
          ),
        },
      ],
    };
  }
  componentDidMount() {
    this.getAdminList();
    this.getRolelist();
  }
  showModal = (e) => {
    this.setState({
      modelTitle: "新增账号",
      passwordShow: true,
      fromItemShow: true,
      roleItemShow: false,
      visible: true,
    });
  };
  handleOk = (e) => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.state.modelTitle === "角色分配") {
          axios
            .post("sys/user/roles", {
              userId: this.state.labelId,
              roleIds: values.roleIds,
            })
            .then((res) => {
              if (res.data.code === 200) {
                message.success("角色分配成功");
                this.getAdminList();
                this.setState({
                  visible: false,
                });
              } else {
                message.error(res.data.msg);
              }
            });
        } else if (this.state.modelTitle === "新增账号") {
          axios
            .post("admin/create", {
              name: values.name,
              password: values.password,
              userName: values.userName,
            })
            .then((res) => {
              if (res.data.code === "200") {
                message.success("添加账号成功");
                this.getAdminList();
                this.setState({
                  visible: false,
                });
              } else {
                message.error(res.data.msg);
              }
            });
        } else if (this.state.modelTitle === "编辑账号") {
          axios
            .post("admin/update", {
              name: values.name,
              userName: values.userName,
              id: this.state.labelId,
            })
            .then((res) => {
              // console.log(res)
              if (res.data.code === "200") {
                message.success("编辑账号成功");
                this.getAdminList();
                this.setState({
                  visible: false,
                });
              } else {
                message.error(res.data.msg);
              }
            });
        } else if (this.state.modelTitle === "重置密码") {
          axios
            .post("admin/reset", {
              password: values.password,
              id: this.state.labelId,
            })
            .then((res) => {
              // console.log(res)
              if (res.data.code === "200") {
                message.success("重置密码成功");
                this.getAdminList();
                this.setState({
                  visible: false,
                });
              } else {
                message.error(res.data.msg);
              }
            });
        }
      }
    });
  };
  getAdminList = (page) => {
    if (page) {
      this.setState({ searchData: page });
    }
    axios
      .post("oaAdmin/getUsers", {
        // pageNum: this.state.pagination.current,
        // pageSize: this.state.pagination.pageSize,
        ...this.state.searchData,
        userName: this.state.userName,
      })
      .then((res) => {
        if (res.data.code === "200") {
          this.setState({
            getAdminListData: res.data.data.list,
            searchData: {
              total: res.data.data.total,
              // pageSize: res.data.data.pageSize,
              pageNum: res.data.data.pageNum,
            },
          });
        }
      });
  };
  delAdmin(id) {
    axios.get(`admin/del/${id}`).then((res) => {
      if (res.data.code === "200") {
        message.success("删除成功");
        this.getAdminList();
      } else {
        message.error(res.data.msg);
      }
    });
  }
  getRolelist = () => {
    axios.get(`sys/user/roles/2`).then((res) => {
      if (res.data.code === 200) {
        const arrdata = res.data.data.allRole.filter((item) => item.status === 1);
        this.setState({
          optionList: arrdata,
        });
      }
    });
  };
  handleCancel = () => {
    this.setState({
      visible: false,
      visiblerole: false,
    });
  };
  render() {
    const { getAdminListData, modelTitle, columns, visible, adminName, fromItemShow, roleItemShow, passwordShow, adminUserName, searchData, editroleIds } = this.state;
    const { getFieldDecorator } = this.props.form;
    const pagination = {
      showSizeChanger: true,
      total: searchData.total,
      pageSizeOptions: ["10", "20", "30", "40"],
      showTotal: () => `共 ${searchData.total} 条`,
      onShowSizeChange: (current, pageSize) => {
        let searchData = this.state.searchData;
        searchData.pageNum = current;
        searchData.pageSize = pageSize;
        this.getAdminList(searchData);
      },
      onChange: (current) => {
        let searchData = this.state.searchData;
        searchData.pageNum = current;
        this.getAdminList(searchData);
      },
    };
    return (
      <div>
        <span style={{ display: "flex", alignItems: "center", fontSize: "18px", fontWeight: "600" }}>账号管理</span>
        <Divider />
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
          <div>
            <Input
              allowClear={true}
              value={this.state.userName}
              style={{ width: "260px", height: "40px", marginRight: "20px" }}
              placeholder="请输入员工姓名"
              onChange={(e) => {
                this.setState({
                  userName: e.target.value,
                });
              }}></Input>
            <Button
              className="my-button-primary"
              type="primary"
              onClick={() => {
                this.getAdminList();
              }}>
              查询
            </Button>
            <span
              className="my-button-txt"
              style={{ marginLeft: "20px" }}
              onClick={() => {
                this.setState(
                  {
                    userName: "",
                  },
                  () => {
                    this.getAdminList();
                  }
                );
              }}>
              重置
            </span>
          </div>
        </div>
        <Table
          dataSource={getAdminListData}
          columns={columns}
          rowKey={(record) => record.id}
          pagination={pagination}
          rowClassName={(record, index) => (index % 2 !== 0 ? "table-line" : "")}
        />

        <Modal
          getContainer={true}
          maskClosable={false}
          title={modelTitle}
          okText="确认"
          cancelText="取消"
          visible={visible}
          onOk={() => {
            this.handleOk();
          }}
          onCancel={() => {
            this.setState({ visible: false });
          }}
          destroyOnClose
          width={800}>
          <Form labelCol={{ span: 5 }} wrapperCol={{ span: 17 }} onSubmit={this.handleOk}>
            {fromItemShow && (
              <Form.Item label={"姓名"}>
                {getFieldDecorator("name", {
                  rules: [
                    { required: true, message: "请输入姓名!" },
                    { max: 50, message: "最多输入50个字符" },
                  ],
                  initialValue: modelTitle === "编辑账号" ? adminName : "",
                })(<Input placeholder="请输入姓名" />)}
              </Form.Item>
            )}
            {fromItemShow && (
              <Form.Item label={"用户名"}>
                {getFieldDecorator("userName", {
                  rules: [
                    { required: true, message: "请输入用户名!" },
                    { max: 20, message: "最多输入50个字符" },
                  ],
                  initialValue: modelTitle === "编辑账号" ? adminUserName : "",
                })(<Input maxLength={20} placeholder="请输入用户名" />)}
              </Form.Item>
            )}
            {passwordShow && (
              <Form.Item label={"密码"}>
                {getFieldDecorator("password", {
                  rules: [
                    { required: true, message: "请输入密码!" },
                    { max: 20, message: "最多输入50个字符" },
                  ],
                })(<Input.Password maxLength={20} password="true" placeholder="请输入密码" />)}
              </Form.Item>
            )}
            {roleItemShow && (
              <Form.Item label={"分配角色"}>
                {getFieldDecorator("roleIds", {
                  rules: [{ required: true, message: "请选择角色!" }],
                  initialValue: modelTitle === "角色分配" ? editroleIds : "",
                })(
                  <Select placeholder="请选择角色">
                    {this.state.optionList.map((item) => {
                      return (
                        <Option placeholder="请选择角色" key={item.id + item.name} value={item.id}>
                          {item.name}
                        </Option>
                      );
                    })}
                  </Select>
                )}
              </Form.Item>
            )}
          </Form>
        </Modal>
      </div>
    );
  }
}

export default Form.create()(Administrators);
